import { getElements } from "@services/storage/elements";
import { $$ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";

interface ProjectStats {
  total: number;
  categories: Record<string, number>;
}

/**
 * Calculate statistics about selected elements
 */
export function calculateProjectStats(): ProjectStats {
  const elements = getElements();
  const stats: ProjectStats = {
    total: 0,
    categories: {},
  };

  // Count elements per category
  Object.values(elements).forEach((element) => {
    stats.total++;

    const category = element.category || "unknown";
    if (!stats.categories[category]) {
      stats.categories[category] = 0;
    }
    stats.categories[category]!++;
  });

  return stats;
}

/**
 * Create a category badge element
 */
function createCategoryBadge(category: string, count: number): HTMLDivElement {
  const badge = document.createElement("div");
  badge.className =
    "text-xs bg-background/50 overflow-hidden rounded flex flex-row justify-center items-center";

  const label = document.createElement("span");
  label.className = "uppercase px-1.5";
  label.textContent = category;

  const countSpan = document.createElement("span");
  countSpan.className = "bg-muted/50 p-1.5";
  countSpan.textContent = String(count);

  badge.appendChild(label);
  badge.appendChild(countSpan);

  return badge;
}

/**
 * Update the project statistics in the sidebar
 * Updates total count and category badges dynamically (desktop and mobile)
 */
export function updateProjectStats(): void {
  const stats = calculateProjectStats();

  // Update total count on all elements
  const totalElements = $$(DATA_ATTR.PROJECT_TOTAL);
  totalElements.forEach((el) => {
    el.textContent = String(stats.total);
  });

  // Update category badges on all containers
  const categoriesContainers = $$(DATA_ATTR.PROJECT_CATEGORIES);
  categoriesContainers.forEach((container) => {
    // Clear existing badges
    container.innerHTML = "";

    // Create badge for each category
    Object.entries(stats.categories)
      .sort(([a], [b]) => a.localeCompare(b)) // Sort alphabetically
      .forEach(([category, count]) => {
        const badge = createCategoryBadge(category, count);
        container.appendChild(badge);
      });
  });
}
